export const getValue = (filter, editingValues, postfix: string) => {
  const valueName = filter.id + postfix;
  return !!valueName && !!editingValues?.[valueName] && editingValues[valueName].value;
};
